<template>
	<div class="row">
		<div class="col-12 mb-4">
			<div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
				<div class="card-body text-center">
					<b-icon icon="exclamation-triangle-fill" variant="danger" font-scale="7.5"></b-icon>
					<h5 class="card-title">{{ $t("not-found") }}</h5>
					<p class="card-text">
						{{ $t("not-found-text") }}
					</p>
					<router-link to="/">
						<button class="btn btn-primary">{{ $t("done") }}</button>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
name: 'NotFoundComponent'
}
</script>
